import { httpGet, httpPost, httpPatchMerge, httpDelete } from './http'
import type { TEntityId } from '~/types/models'
import type { ITsd, ITsdOverview, ITsdSupplier } from '~/types/tsd/models'
import type { ITsdContact } from '~/types/contact/models'
import { TsdContact } from '~/cynqueModules/dataObjects/TsdContact'

const apiEntityPath = '/api/tsds'

export async function getTsds({ apiPath = apiEntityPath } = {}) {
  const callingMn = getTsds.name
  return httpGet<ITsd[]>({ callingMn, apiPath })
}

export async function getTsdOverview(id: TEntityId) {
  const callingMn = getTsdOverview.name
  const apiPath = `${apiEntityPath}/${id}/overview`
  return httpGet<ITsdOverview>({ callingMn, apiPath })
}

export async function getTsdSuppliersByTsdId(id: TEntityId) {
  const callingMn = getTsdSuppliersByTsdId.name
  const apiPath = `${apiEntityPath}/${id}/suppliers`
  return httpGet<ITsdSupplier[]>({ callingMn, apiPath })
}

export async function getContactsForTsdIdPreProcessed(id: TEntityId) {
  const callingMn = getContactsForTsdIdPreProcessed.name
  const apiPath = `${apiEntityPath}/${id}/contacts`
  const rawContacts = await httpGet<ITsdContact[]>({
    callingMn,
    apiPath,
  })
  return rawContacts.map((rawContact) =>
    Object.assign(rawContact, TsdContact(rawContact))
  )
}

export async function createTsd(entity: ITsd) {
  const callingMn = createTsd.name
  const apiPath = apiEntityPath
  return httpPost<ITsd>({ callingMn, apiPath, entity })
}

export async function updateTsd(entityData: Partial<ITsd>, id: TEntityId) {
  const callingMn = updateTsd.name
  const apiPath = `${apiEntityPath}/${id}`
  type TPartialITsd = Partial<ITsd>
  return httpPatchMerge<TPartialITsd>({
    callingMn,
    apiPath,
    entityData,
  })
}

export async function deleteTsd(entityData: ITsd) {
  const callingMn = deleteTsd.name
  const apiPath = apiEntityPath
  return httpDelete<ITsd>({
    callingMn,
    apiPath,
    entityData,
  })
}
